import defaultState from "./state";

const resumenReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_DASHBOARD": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }

    case "SET_RANGE_MONTH": {
      return Object.assign({}, state, {
        range: action.range,
      });
    }

    default:
      return state;
  }
};

export default resumenReducer;
